module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inicial-bodies col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2 px-0"
  }, [_c('div', {
    staticClass: "inicial-body2 inicial-body-step-2 is-showing"
  }, [_c('div', {
    staticClass: "formulario-login-topo"
  }, [_c('img', {
    staticClass: "pull-left logo-equals",
    attrs: {
      "src": _vm.logoEqualsLoginPng,
      "alt": "EQUALS"
    }
  }), _c('button', {
    staticClass: "btn btn-idioma",
    attrs: {
      "title": _vm.$t('login.titulos.abrirSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.escolherIdioma()
      }
    }
  }, [(!_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e(), (_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaAtivoPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abrirIdiomas),
      expression: "abrirIdiomas"
    }],
    staticClass: "escolhaIdiomas col-sm-12 px-0"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "pull-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.idioma'))
    }
  }), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-pt btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('pt')
      }
    }
  }, [_vm._v("PT")]), _c('button', {
    staticClass: "btn-in btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.eng')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('in')
      }
    }
  }, [_vm._v("ENG")]), _c('button', {
    staticClass: "btn-es btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.esp')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('es')
      }
    }
  }, [_vm._v("ESP")])]), _c('button', {
    staticClass: "btn btn-fechar-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.fecharSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.fecharEscolherIdioma()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fecharPng,
      "width": "23",
      "height": "23"
    }
  })])])])]), (!_vm.success) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.cadastrar.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formulario-login"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nome",
      "type": "text",
      "placeholder": _vm.$t('login.placeholders.usuario')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), (_vm.campoUsernamaVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailVazio'))
    }
  }) : _vm._e(), (_vm.campoUsernameInvalido) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailInvalido'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "senha",
      "placeholder": _vm.$t('login.placeholders.senha'),
      "type": "password"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), (_vm.campoPassVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.senhaVazia'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPass),
      expression: "confirmPass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "confirmaSenha",
      "placeholder": _vm.$t('login.placeholders.confirmarSenha'),
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPass = $event.target.value
      }
    }
  }), (_vm.campoConfirmPassVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.confirmacaoDeSenha'))
    }
  }) : _vm._e(), (_vm.senhaDiferente) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.senhasDiferentes'))
    }
  }) : _vm._e()])]), _c('button', {
    staticClass: "btn button-login",
    attrs: {
      "type": "submit",
      "title": _vm.$t('login.titulos.cadastrarSenha'),
      "disabled": _vm.disableCreateButton
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.cadastrarSenha'))
    }
  })]) : _vm._e(), (_vm.success) ? _c('div', {
    staticClass: "formulario-login logado"
  }, [_c('img', {
    attrs: {
      "src": _vm.logadoOkPng,
      "width": "89",
      "height": "89"
    }
  }), _c('div', {
    staticClass: "logado-ok",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.sucesso.login'))
    }
  }), _c('div', {
    staticClass: "bem-vindo",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.sucesso.cadastrarSenha'))
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "img-bottom"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("ambiente-seguro-")
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-6 text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("premio-br-week-")
    }
  })]), _c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("certificado-saae18-")
    }
  })])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bd12989", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd12989"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/login/cadastrarSenha.pug
// module id = 1430
// module chunks = 0